import { render, staticRenderFns } from "./select-board-type.vue?vue&type=template&id=1de2b8ba&scoped=true&"
import script from "./select-board-type.vue?vue&type=script&lang=ts&"
export * from "./select-board-type.vue?vue&type=script&lang=ts&"
import style0 from "./select-board-type.vue?vue&type=style&index=0&id=1de2b8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de2b8ba",
  null
  
)

export default component.exports